import { render, staticRenderFns } from "./ProviderEditTabForms.vue?vue&type=template&id=e601939e&scoped=true&"
import script from "./ProviderEditTabForms.vue?vue&type=script&lang=js&"
export * from "./ProviderEditTabForms.vue?vue&type=script&lang=js&"
import style0 from "./ProviderEditTabForms.vue?vue&type=style&index=0&id=e601939e&lang=scss&scoped=true&"
import style1 from "./ProviderEditTabForms.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e601939e",
  null
  
)

export default component.exports